<span *ngFor="let cmsReplace of cmsReplaces">
    <span [innerHtml]="cmsReplace.beforeText | safeHtml"></span>
    <a *ngIf="cmsReplace.internalLink"
        [ngClass]="{ 'xm-btn-primary-light': cmsReplace.displayAsPrimary, 'xm-btn-secondary-light': cmsReplace.displayAsSecondary, 'xm-btn-link-light': cmsReplace.displayAsLink, 'inline-text-replace': cmsReplace.useParentStyles, 'disabled': disableClick }"
        [uiSref]="cmsReplace.linkAction"
        [uiParams]="cmsReplace.linkParams"
        [attr.aria-label]="cmsReplace.linkAccessibility"
        [innerHtml]="cmsReplace.linkName | safeHtml"
        [attr.target]="cmsReplace.linkTarget"
        [attr.banner]="cmsReplace.linkAnalytics"
        [attr.disabled]="disableClick ? true : null">
    </a>
    <a *ngIf="cmsReplace.externalLink"
        [ngClass]="{ 'xm-btn-primary-light': cmsReplace.displayAsPrimary, 'xm-btn-secondary-light': cmsReplace.displayAsSecondary, 'xm-btn-link-light': cmsReplace.displayAsLink, 'fcc-label-link-text': broadbandLabelLink, 'fcc-label-header-link-text': broadbandHeaderLink, 'inline-text-replace': cmsReplace.useParentStyles, 'disabled': disableClick }"
        [href]="safeUrl(cmsReplace.linkAction)"
        [attr.aria-label]="cmsReplace.linkAccessibility"
        [innerHtml]="cmsReplace.linkName | safeHtml"
        target="{{ cmsReplace.linkTarget }}"
        [attr.banner]="cmsReplace.linkAnalytics"
        [attr.disabled]="disableClick ? true : null">
    </a>
    <button *ngIf="cmsReplace.buttonLink" xmAriaFocus
        [ngClass]="{ 'xm-btn-primary-light': cmsReplace.displayAsPrimary, 'xm-btn-secondary-light': cmsReplace.displayAsSecondary, 'xm-btn-link-light': cmsReplace.displayAsLink, 'inline-text-replace': cmsReplace.useParentStyles, 'disabled': disableClick }"
        (click)="buttonClick($event)"
        [attr.aria-label]="cmsReplace.linkAccessibility"
        [innerHtml]="cmsReplace.linkName | safeHtml"
        [attr.banner]="cmsReplace.linkAnalytics"
        [disabled]="disableClick">
    </button>
</span>
<span [xmAriaHidden]="isAriaHidden" [innerHtml]="afterText | safeHtml"></span>
<ng-content></ng-content>
